import { mapIdToCalendarDate } from "@dailywars/core/engine";
import { isMedalEligibleDate } from "@dailywars/core/medals";

import { SectionHeader } from "#/components/SectionHeader";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "#/components/ui/card";

import type { LeaderboardEntry } from "./-play.labels";
import { MapDayLeaderboard } from "./-play.mapDayLeaderboard";

export type YesterdayBoards = {
  yesterdayStandardMapId: string;
  yesterdayPremiumMapId: string;
  yesterdayStandardLeaderboard: LeaderboardEntry[];
  yesterdayPremiumLeaderboard: LeaderboardEntry[];
};

export function LearnFromTheBestSection({ boards }: { boards: YesterdayBoards }) {
  const standardMedalsVisible = isMedalEligibleDate(
    mapIdToCalendarDate(boards.yesterdayStandardMapId),
  );
  const premiumMedalsVisible = isMedalEligibleDate(
    mapIdToCalendarDate(boards.yesterdayPremiumMapId),
  );

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>
          <SectionHeader>Learn from the best</SectionHeader>
        </CardTitle>
        <CardDescription>
          Watch the replays of how yesterday&apos;s top scorers cleared each map. More replays are
          available on each map&apos;s leaderboard page.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid w-full grid-cols-1 items-stretch gap-6 sm:grid-cols-2">
          <MapDayLeaderboard
            title="Yesterday's Standard"
            entries={boards.yesterdayStandardLeaderboard}
            mapId={boards.yesterdayStandardMapId}
            medalsVisible={standardMedalsVisible}
            showReplays
          />
          <MapDayLeaderboard
            title="Yesterday's Premium"
            entries={boards.yesterdayPremiumLeaderboard}
            mapId={boards.yesterdayPremiumMapId}
            medalsVisible={premiumMedalsVisible}
            showReplays
          />
        </div>
      </CardContent>
    </Card>
  );
}
